!function () {
  var t = [],
      e = document.querySelectorAll(".table-stack th"),
      n = document.querySelectorAll(".table-stack tr"),
      o = document.querySelector(".table-stack tbody");if (e && n && o) {
    for (var r = 0; r < e.length; r++) {
      var a = e[r];t.push(a.textContent.replace(/\r?\n|\r/, ""));
    }for (var i, r = 0; i = o.rows[r]; r++) for (var s, l = 0; s = i.cells[l]; l++) s.setAttribute("data-heading", t[l]), s.setAttribute("title", t[l]);
  }
}(), function (t) {
  "undefined" != typeof module && "object" == typeof exports ? "undefined" != typeof window ? module.exports = t() : module.exports = t : window.Tab = t();
}(function () {
  var t = function (t, e) {
    e = e || {}, this.isIE = null != new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})").exec(navigator.userAgent) && parseFloat(RegExp.$1), this.tab = "object" == typeof t ? t : document.querySelector(t), this.tabs = this.tab.parentNode.parentNode, this.dropdown = this.tabs.querySelector(".dropdown"), /\bdropdown-menu/.test(this.tabs.className) && (this.dropdown = this.tabs.parentNode, this.tabs = this.tabs.parentNode.parentNode), this.options = e, this.duration = 150, this.options.duration = this.isIE && this.isIE < 10 ? 0 : e.duration || this.duration, this.init();
  };t.prototype = { init: function () {
      this.actions(), this.tab.addEventListener("click", this.action, !1);
    }, actions: function () {
      var t = this;this.action = function (e) {
        e = e || window.e, e.preventDefault();var n = e.target,
            o = document.getElementById(n.getAttribute("href").replace("#", "")),
            r = new RegExp("(?:^|\\s)dropdown-menu(?!\\S)"),
            a = t.getActiveTab(),
            i = t.getActiveContent();/\bactive/.test(n.parentNode.className) || (t.removeClass(a, "active"), t.addClass(n.parentNode, "active"), t.dropdown && (r.test(t.tab.parentNode.parentNode.className) ? /\bactive/.test(t.dropdown.className) || t.addClass(t.dropdown, "active") : /\bactive/.test(t.dropdown.className) && t.removeClass(t.dropdown, "active")), t.removeClass(i, "in"), setTimeout(function () {
          t.removeClass(i, "active"), t.addClass(o, "active");
        }, t.options.duration), setTimeout(function () {
          t.addClass(o, "in");
        }, 2 * t.options.duration));
      }, this.addClass = function (t, e) {
        t.classList ? t.classList.add(e) : t.className += " " + e;
      }, this.removeClass = function (t, e) {
        t.classList ? t.classList.remove(e) : t.className = t.className.replace(e, "").replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      }, this.getActiveTab = function () {
        var t = this.tabs.querySelectorAll(".active");return 1 !== t.length || /\bdropdown/.test(t[0].className) ? t.length > 1 ? t[t.length - 1] : void 0 : t[0];
      }, this.getActiveContent = function () {
        var t = this.getActiveTab().getElementsByTagName("a")[0].getAttribute("href").replace("#", "");return t && document.getElementById(t);
      };
    } };var e = document.querySelectorAll("[data-toggle='tab'], [data-toggle='pill']"),
      n = e.length,
      o = 0;for (o; o < n; o++) {
    var r = e[o],
        a = {};a.duration = r.getAttribute("data-duration") && r.getAttribute("data-duration") || !1, new t(r, a);
  }return t;
}), function (t) {
  "undefined" != typeof module && "object" == typeof exports ? "undefined" != typeof window ? module.exports = t() : module.exports = t : window.Collapse = t();
}(function () {
  var t = function (t, e) {
    e = e || {}, this.isIE = null != new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})").exec(navigator.userAgent) && parseFloat(RegExp.$1), this.btn = "object" == typeof t ? t : document.querySelector(t), this.accordion = null, this.collapse = null, this.duration = 300, this.options = {}, this.options.duration = this.isIE && this.isIE < 10 ? 0 : e.duration || this.duration, this.init();
  };t.prototype = { init: function () {
      this.actions(), this.addEvent(), this.collapse = this.getTarget(), this.accordion = this.btn.getAttribute("data-parent") && this.getClosest(this.btn, this.btn.getAttribute("data-parent"));
    }, actions: function () {
      var t = this,
          e = function (t) {
        var e = t && (t.currentStyle || window.getComputedStyle(t)),
            n = /px/.test(e.borderTopWidth) ? Math.round(e.borderTopWidth.replace("px", "")) : 0,
            o = /px/.test(e.marginTop) ? Math.round(e.marginTop.replace("px", "")) : 0,
            r = /px/.test(e.marginBottom) ? Math.round(e.marginBottom.replace("px", "")) : 0,
            a = /em/.test(e.marginTop) ? Math.round(e.marginTop.replace("em", "") * parseInt(e.fontSize)) : 0,
            i = /em/.test(e.marginBottom) ? Math.round(e.marginBottom.replace("em", "") * parseInt(e.fontSize)) : 0;return t.clientHeight + parseInt(n) + parseInt(o) + parseInt(r) + parseInt(a) + parseInt(i);
      };this.toggle = function (e) {
        e.preventDefault(), /\bin/.test(t.collapse.className) ? t.close() : t.open();
      }, this.close = function () {
        t._close(t.collapse), t.addClass(t.btn, "collapsed");
      }, this.open = function () {
        if (t._open(t.collapse), t.removeClass(t.btn, "collapsed"), null !== t.accordion) {
          var e = t.accordion.querySelectorAll(".collapse.in"),
              n = e.length,
              o = 0;for (o; o < n; o++) e[o] !== t.collapse && t._close(e[o]);
        }
      }, this._open = function (e) {
        t.removeEvent(), t.addClass(e, "in"), e.setAttribute("aria-expanded", "true"), t.addClass(e, "collapsing"), setTimeout(function () {
          e.style.height = t.getMaxHeight(e) + "px", e.style.overflowY = "hidden";
        }, 0), setTimeout(function () {
          e.style.height = "", e.style.overflowY = "", t.removeClass(e, "collapsing"), t.addEvent();
        }, t.options.duration);
      }, this._close = function (e) {
        t.removeEvent(), e.setAttribute("aria-expanded", "false"), e.style.height = t.getMaxHeight(e) + "px", setTimeout(function () {
          e.style.height = "0px", e.style.overflowY = "hidden", t.addClass(e, "collapsing");
        }, 0), setTimeout(function () {
          t.removeClass(e, "collapsing"), t.removeClass(e, "in"), e.style.overflowY = "", e.style.height = "", t.addEvent();
        }, t.options.duration);
      }, this.getMaxHeight = function (t) {
        for (var n = 0, o = 0, r = t.children.length; o < r; o++) n += e(t.children[o]);return n;
      }, this.removeEvent = function () {
        this.btn.removeEventListener("click", this.toggle, !1);
      }, this.addEvent = function () {
        this.btn.addEventListener("click", this.toggle, !1);
      }, this.getTarget = function () {
        var t = this.btn,
            e = t.href && t.getAttribute("href").replace("#", ""),
            n = t.getAttribute("data-target") && t.getAttribute("data-target"),
            o = e || n && /#/.test(n) && n.replace("#", ""),
            r = n && "." === n.charAt(0) && n,
            a = o && document.getElementById(o) || r && document.querySelector(r);return a;
      }, this.getClosest = function (t, e) {
        for (var n = e.charAt(0); t && t !== document; t = t.parentNode) {
          if ("." === n && void 0 !== document.querySelector(e)) return t;if ("#" === n && t.id === e.substr(1)) return t;
        }return !1;
      }, this.addClass = function (t, e) {
        t.classList ? t.classList.add(e) : t.className += " " + e;
      }, this.removeClass = function (t, e) {
        t.classList ? t.classList.remove(e) : t.className = t.className.replace(e, "").replace(/^\s+|\s+$/g, "");
      };
    } };var e = document.querySelectorAll('[data-toggle="collapse"]'),
      n = 0,
      o = e.length;for (n; n < o; n++) {
    var r = e[n],
        a = {};a.duration = r.getAttribute("data-duration"), new t(r, a);
  }return t;
}), function (t) {
  "use strict";
  var e = function (t, e) {
    for (var n in e) e.hasOwnProperty(n) && e[n] && (t[n] = e[n]);return t;
  },
      n = function (t, e) {
    var n = [],
        o = document.querySelectorAll(e);return Array.prototype.forEach.call(o, function (e) {
      var o = e.querySelectorAll(t);n = n.concat(Array.prototype.slice.call(o));
    }), n;
  },
      o = function (t) {
    if ("string" != typeof t) return 0;var e = t.match(/\d/g);return e ? Math.min.apply(null, e) : 1;
  },
      r = function (t, e) {
    for (; e--;) t = t.appendChild(document.createElement("ul")), e && (t = t.appendChild(document.createElement("li")));return t;
  },
      a = function (t, e) {
    for (; e--;) t = t.parentElement;return t;
  },
      i = function (t, e) {
    return function (n, o, r) {
      var a = n.textContent,
          i = e + "-" + r;o.textContent = a;var s = t ? i : n.id || i;s = encodeURIComponent(s), n.id = s, o.href = "#" + s;
    };
  },
      s = function (t) {
    var e = t.selector,
        s = t.scope,
        l = document.createElement("ol"),
        c = l,
        d = null,
        u = i(t.overwrite, t.prefix);return n(e, s).reduce(function (t, e, n) {
      var i = o(e.tagName),
          s = i - t;s > 0 && (c = r(d, s)), s < 0 && (c = a(c, 2 * -s)), c = c || l;var p = document.createElement("li"),
          h = document.createElement("a");return u(e, h, n), c.appendChild(p).appendChild(h), d = p, i;
    }, o(e)), l;
  },
      l = function (t) {
    var n = { selector: "h1, h2, h3, h4, h5, h6", scope: "body", overwrite: !1, prefix: "toc" };t = e(n, t);var o = t.selector;if ("string" != typeof o) throw new TypeError("selector must be a string");if (!o.match(/^(?:h[1-6],?\s*)+$/g)) throw new TypeError("selector must contains only h1-6");var r = location.hash;return r && setTimeout(function () {
      location.hash = "", location.hash = r;
    }, 0), s(t);
  };"function" == typeof define && define.amd ? define(function () {
    return l;
  }) : t.initTOC = l;
}(window);